import request from '@/util/request';

// 分页列表
export const getPageListApi = (params, options) =>
  request.get('/api/v4ward/callcenter/leavemessage/page', Object.assign({}, options, { params }));

// 处理语音留言
export const dealVoiceMsgApi = (params, options) =>
  request.post('/api/v4ward/callcenter/leavemessage/update', params, options, {
    'Content-Type': 'application/json',
  });
